export const localStorageGet = (key: string): string | null => {
	return localStorage.getItem(key);
};

export const localStorageSet = (key: string, value: string): void => {
	localStorage.setItem(key, value);
};

export const localStorageRemove = (key: string): void => {
	localStorage.removeItem(key);
};
